import React, { useState } from 'react';
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  Collapse,
  Box,
} from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface ConceptCardProps {
  title: string;
  summary: string;
  details: string;
}

const ConceptCard: React.FC<ConceptCardProps> = ({
  title,
  summary,
  details,
}) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Card variant="outlined" sx={{ mb: 2, bgcolor: 'background.paper' }}>
      <CardContent sx={{ pb: 1 }}>
        <Box display="flex" alignItems="center" gap={1} mb={1}>
          <SchoolIcon color="primary" fontSize="small" />
          <Typography variant="subtitle2" fontWeight="bold">
            {title}
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary">
          {summary}
        </Typography>
      </CardContent>
      <CardActions sx={{ justifyContent: 'flex-end', pt: 0 }}>
        <Button
          size="small"
          endIcon={
            <ExpandMoreIcon
              sx={{
                transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: '0.3s',
              }}
            />
          }
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? 'Less' : 'Learn More'}
        </Button>
      </CardActions>
      <Collapse in={expanded}>
        <CardContent sx={{ pt: 0, borderTop: 1, borderColor: 'divider' }}>
          <Typography variant="body2" sx={{ mt: 2 }}>
            {details}
          </Typography>
        </CardContent>
      </Collapse>
    </Card>
  );
};

export default ConceptCard;
